// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessWindturbine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.875 8.855a.25.25 0 0 0 .01.21l2.7 5.193c.948 1.821-1.473 3.504-2.85 1.982l-1.722-1.903V18h1.741c.69 0 1.25.56 1.25 1.25v1.5c0 .69-.56 1.25-1.25 1.25H8.221c-.69 0-1.25-.56-1.25-1.25v-1.496a1.25 1.25 0 0 1 1.257-1.25l1.766.01v-6.461l-4.531-.454c-2.067-.206-2.116-3.201-.058-3.476l6.07-.809a.25.25 0 0 0 .17-.103l3.232-4.562c1.202-1.697 3.834-.254 3.049 1.672zm-3.361 3.824-.806-.89a.25.25 0 0 0-.16-.081l-.054-.005v6.563a1.25 1.25 0 0 1-1.257 1.25l-1.766-.011v.995h7.033v-1h-1.74c-.69 0-1.25-.56-1.25-1.25zm.356-5.101a1.75 1.75 0 0 1-1.197.723l-6.07.81c-.104.013-.144.052-.165.078a.276.276 0 0 0-.051.173.276.276 0 0 0 .056.171c.022.026.064.063.169.074l6.085.608a1.75 1.75 0 0 1 1.124.568l4.027 4.45c.069.077.123.09.157.092a.276.276 0 0 0 .17-.054.275.275 0 0 0 .11-.141c.01-.033.017-.088-.03-.18l-2.701-5.194a1.75 1.75 0 0 1-.068-1.467l2.05-5.034c.04-.098.027-.152.015-.183a.276.276 0 0 0-.125-.13.277.277 0 0 0-.178-.036c-.033.006-.086.024-.147.11z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessWindturbine;
